(async function waitForTryNow() {
    while (typeof window.trynow === 'undefined' || window.trynow === null) {
      await new Promise(resolve => setTimeout(resolve, 50)); 
    }

    if(window.Shopify.country != 'US'){
      const style = document.createElement("style");
      style.innerHTML = `
        .trynow-subhero-banner,
        [link-title="Try Before You Buy"],
        [link-title="Try At Home"],
        .tryNowCtaBanner.tryNowCtaBannerDesktop,
        .tryNowCtaBanner.tryNowCtaBannerMobile,
        .trynowBadgeLabel,
        .trynowBadgeLabel.trynowBadgeLabelMobile,
        .tnDescription,
        .trynowBadgeLabelToggle,
        .tryNowPriceToggle,
        .try-banner,
        .tryNow_quick_link,
        .trynow-grid-item,
        #HeaderMenu-try-it-free,
        div:has(>img[alt="Try Free"]),
        #_loomi_addon_1754388218096,
        .tryNowSwitch {
          display: none !important;
        }

        ProductMeta__PriceList.Heading.Price_List_Mobile.observer .ProductMeta__Price.ProductDynamic_Money {
          display: block !important;
        }

        .Heading.Price_List_Mobile.observer .ProductMeta__Price.Price.Price--compareAt {
          display: unset !important;
        }

        .Heading.Price_List_Mobile.observer .ProductMeta__Price.Price.Price--highlight {
          display: unset !important;
        }

        .ProductMeta__PriceList.Heading.Price_List_Desktop.observer .ProductMeta__Price.ProductDynamic_Money {
          display: block !important;
        }

        .tbyb-atc-meta-blocked {
          display: unset !important;
        }
      `;
      document.head.appendChild(style);
    }


  })();
 